import React from "react";

const ACCENTS = {
  indigo:
    "border-indigo-200 bg-indigo-50 text-indigo-700 " +
    "dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",

  emerald:
    "border-emerald-200 bg-emerald-50 text-emerald-700 " +
    "dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",

  amber:
    "border-amber-200 bg-amber-50 text-amber-700 " +
    "dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",

  rose:
    "border-rose-200 bg-rose-50 text-rose-700 " +
    "dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300",
};

export default function CompactStat({
  icon,
  label,
  value,
  accent = "indigo",
}) {
  const accentClass =
    ACCENTS[accent] || ACCENTS.indigo;

  return (
    <div
      className={`rounded-2xl border px-3 py-3 ${accentClass}`}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/80 dark:bg-slate-900/50">
          {icon}
        </div>

        <div className="min-w-0">
          <div className="text-[11px] uppercase tracking-[0.16em] opacity-75">
            {label}
          </div>

          <div className="mt-0.5 text-xl font-bold text-slate-900 dark:text-white">
            {value}
          </div>
        </div>
      </div>
    </div>
  );
}